var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 40,
    viewBox: "0 0 46 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.834839,
    width: 44.893,
    height: 40,
    rx: 5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9084 23.1294L12.7364 27.0277L8.45278 27.1085C7.17261 24.9928 6.44647 22.5723 6.44647 20C6.44647 17.5127 7.12539 15.167 8.32882 13.1017H8.32974L12.1434 13.7246L13.814 17.1022C13.4643 18.0105 13.2737 18.9855 13.2737 20C13.2739 21.1011 13.4977 22.1561 13.9084 23.1294Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.822 17.1978C40.0154 18.1052 40.1162 19.0423 40.1162 20C40.1162 21.0739 39.9895 22.1214 39.7481 23.1319C38.9285 26.5703 36.7872 29.5728 33.8207 31.6975L33.8198 31.6967L29.0164 31.4783L28.3365 27.697C30.3049 26.6684 31.8432 25.0588 32.6535 23.1319H23.6514V17.1978H32.7848H39.822Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8198 31.6967L33.8207 31.6975C30.9357 33.7637 27.2708 35 23.2814 35C16.8703 35 11.2963 31.8072 8.45282 27.1085L13.9084 23.1294C15.3301 26.5102 18.9903 28.9168 23.2814 28.9168C25.1258 28.9168 26.8537 28.4725 28.3364 27.697L33.8198 31.6967Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0269 8.45328L28.5732 12.4316C27.0386 11.5769 25.2247 11.0832 23.2813 11.0832C18.8931 11.0832 15.1645 13.6002 13.814 17.1022L8.32972 13.1016H8.3288C11.1306 8.28846 16.7749 5 23.2813 5C27.3661 5 31.1114 6.29645 34.0269 8.45328Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6697,
    height: 30,
    fill: "white",
    transform: "translate(6.44647 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.e3d4e092e77e48a1afec024faa232637.svg";
export { ForwardRef as ReactComponent };